var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30625 9.92136L7.1875 10.8026L10.3125 7.67761L7.1875 4.55261L6.30625 5.43386L7.91875 7.05261H1.875V8.30261H7.91875L6.30625 9.92136ZM11.875 2.05261H3.125C2.43125 2.05261 1.875 2.61511 1.875 3.30261V5.80261H3.125V3.30261H11.875V12.0526H3.125V9.55261H1.875V12.0526C1.875 12.7401 2.43125 13.3026 3.125 13.3026H11.875C12.5625 13.3026 13.125 12.7401 13.125 12.0526V3.30261C13.125 2.61511 12.5625 2.05261 11.875 2.05261Z",
    fill: "#817393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogOut);
export default __webpack_public_path__ + "static/media/AccountLogOut.1e1b0511e98c09f0bd8555aa871bab68.svg";
export { ForwardRef as ReactComponent };